module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms2_m_jp.73a8242fca47460a649d6aac945d376e.png";